/* eslint-disable */
import * as util from "@/api/instagramSchedule";
import { formatLocalDateYMD, currentDateTimeUnix } from "@/utils/helper"

const state = {
    events_calendar: [],
    formParamListScrapingSt: {
        columnFilters: {
            start_date: "",
            end_date: "",
            product_id: "",
            brand_id: "",
            product_price_start: "",
            product_price_end: "",
        },
        page: 1,
        perPage: 20,
        more_search: false
    },
    isShowFormSummary: false,
    isShowFormSummaryId: "",
    isShowForm: false,
    formParamScrapeSt: {
        id: "",
        title: "",
        brand_id: "",
        instagram_account_id: [],
        assets_url: [],
        media_type: 'photo',
        caption: '',
        sending_options: 1,
        is_publish: 1,
        sending_schedule: "",
        is_recurring: 0,
        is_official: 0,
        recurring_form: {
            recurrence: "",
            recurrence_time: "00:01",
            recurrence_every: "",
            recurrence_annually_month: "",
            recurrence_end: "never",
            recurrence_end_date: ""
        },
    },
    formParamSt: {
        columnFilters: {
            start_date: "",
            end_date: "",
            brand_id: "",
            instagram_account_id: "",
            media_type: "",
        },
        page: 1,
        perPage: 20,
        more_search: false
    },
    formParamStB: {
        columnFilters: {
            start_date: "",
            end_date: "",
            brand_id: "",
            instagram_account_id: "",
            media_type: "",
        },
        page: 1,
        perPage: 20,
        more_search: false
    },
    formParamListLogSt: {
        columnFilters: {
            start_date: "",
            end_date: "",
            brand_id: "",
            instagram_account_id: "",
            media_type: "",
            post_status: "",
        },
        page: 1,
        perPage: 20,
        more_search: false
    },
    formParamListLogStB: {
        columnFilters: {
            start_date: "",
            end_date: "",
            brand_id: "",
            instagram_account_id: "",
            media_type: "",
            post_status: "",
        },
        page: 1,
        perPage: 20,
        more_search: false
    },
};

const mutations = {
    SET_EVENTS_CALENDAR: (state, value) => {
        let event = []
        for (let i of value.data) {
            let startDate = i.update_datetime;
            let endDate = i.update_datetime;

            if (i.is_publish == 1) {
                if (i.sending_options == 2 && i.sending_schedule > currentDateTimeUnix()) {
                    startDate = i.sending_schedule;
                    endDate = i.sending_schedule;
                }
            }

            event.push({
                title: i.caption || i.title,
                start: formatLocalDateYMD(startDate),
                end: formatLocalDateYMD(endDate),
                event_id: i.id,
                event_permalink: i.id
            })
        }
        state.events_calendar = event
    },
    SET_formParamListScrapingSt: (state, value) => {
        state.formParamListScrapingSt = value
    },
    SET_formParamScrapeSt: (state, value) => {
        state.formParamScrapeSt = value
    },
    SET_formParamListLogSt: (state, value) => {
        state.formParamListLogSt = value
    },
    SET_formParamListLogStB: (state, value) => {
        state.formParamListLogStB = value
    },
    SET_formParamSt: (state, value) => {
        state.formParamSt = value
    },
    SET_formParamStB: (state, value) => {
        state.formParamStB = value
    },
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
    SET_isShowFormSummary: (state, value) => {
        state.isShowFormSummary = value
    },
    SET_isShowFormSummaryId: (state, value) => {
        state.isShowFormSummaryId = value
    },
};

const actions = {
    setIsShowFormSummary({ commit }, data) {
        commit("SET_isShowFormSummary", data);
    },
    setIsShowFormSummaryId({ commit }, data) {
        commit("SET_isShowFormSummaryId", data);
    },
    actFormParamListLogSt({ commit }, data) {
        commit("SET_formParamListLogSt", data);
    },
    actFormParamListLogStB({ commit }, data) {
        commit("SET_formParamListLogStB", data);
    },
    listLogs({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listLogs(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    summaryLogs({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.summaryLogs(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    schedulePreparing({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.schedulePreparing(params).then(response => {
                commit("SET_formParamScrapeSt", {
                    id: "",
                    title: "",
                    brand_id: "",
                    instagram_account_id: [],
                    assets_url: [],
                    media_type: 'photo',
                    caption: '',
                    sending_options: 1,
                    is_publish: 1,
                    sending_schedule: "",
                    is_recurring: 0,
                    recurring_form: {
                        recurrence: "",
                        recurrence_time: "00:01",
                        recurrence_every: "",
                        recurrence_annually_month: "",
                        recurrence_end: "never",
                        recurrence_end_date: ""
                    },
                });

                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamScrapeSt({ commit }, data) {
        commit("SET_formParamScrapeSt", data);
    },
    getMediaTypeList() {
        return new Promise((resolve, reject) => {
            util.getMediaTypeList().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMediaTypeListS() {
        return new Promise((resolve, reject) => {
            util.getMediaTypeListS().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSchedule({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSchedule(params).then(response => {
                commit('SET_EVENTS_CALENDAR', response.data)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listScheduleById({ commit }, params) {
      return new Promise((resolve, reject) => {
          util.listSchedule(params).then(response => {
              resolve(response);
          }).catch(error => {
              reject(error);
          });
      });
  },
    actionStore({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionStore(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getDetailEditByScheduleId({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.getDetailEditByScheduleId(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getDetailLog({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.getDetailLog(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    // scrapingActionStored({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.scrapingActionStored(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // getMarketplaceByScheduleId({ commit }, id) {
    //     return new Promise((resolve, reject) => {
    //         util.getMarketplaceByScheduleId(id).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // getKeywordsByScheduleId({ commit }, id) {
    //     return new Promise((resolve, reject) => {
    //         util.getKeywordsByScheduleId(id).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },

    // retryScrapingRawDetail({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.retryScrapingRawDetail(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // scrapingDetailProduct({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.scrapingDetailProduct(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // listLinkExcel({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.listLinkExcel(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },

    // detailKeywords({ commit }, id) {
    //     return new Promise((resolve, reject) => {
    //         util.detailKeywords(id).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // addKeywords({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.addKeywords(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // listKeywords({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.listKeywords(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // getMonitoringSortByList() {
    //     return new Promise((resolve, reject) => {
    //         util.getMonitoringSortByList().then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // getMarketplaceList() {
    //     return new Promise((resolve, reject) => {
    //         util.getMarketplaceList().then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // getMonitoringListStatus() {
    //     return new Promise((resolve, reject) => {
    //         util.getMonitoringListStatus().then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },

    // listLog({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.listLog(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    // listLink({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         util.listLink(params).then(response => {
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },
    actFormParamSt({ commit }, data) {
        commit("SET_formParamSt", data);
    },
    actFormParamStB({ commit }, data) {
        commit("SET_formParamStB", data);
    },
    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/instagramSchedule.js